import { DEFAULT_LOCATION } from "./locations.model";

export const DEFAULT_AREA = {
  areaName: "Default",
  displayText: "",
  location: DEFAULT_LOCATION,
  displayOrder: 1,
};
